import { useEffect, useState, type FormEvent } from 'react'
import { ArrowLeft, Eye, EyeOff, LoaderCircle, LockKeyhole, Mail, ShieldCheck, Target } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { auth, errorMessage } from '../lib/api'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [show, setShow] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  useEffect(() => { if (auth.token()) navigate('/') }, [navigate])

  const submit = async (event: FormEvent) => {
    event.preventDefault(); setError(''); setBusy(true)
    try { await auth.login(email, password); navigate('/') } catch (err) { setError(errorMessage(err)) } finally { setBusy(false) }
  }

  return <main className="login-page">
    <section className="login-story">
      <div className="login-brand"><Target /><div><strong>منصة دراية 3</strong><span>مؤسسة صيتة بنت عبدالعزيز</span></div></div>
      <div className="login-copy"><span className="eyebrow">غرفة عمليات الرعايات</span><h1>من الاستهداف إلى الإغلاق،<br /><em>كل قرار أصبح قابلًا للقياس.</em></h1><p>منصة موحدة لمتابعة الشركات وصناع القرار والحملات البريدية والتسجيلات والإعلانات وصولًا إلى هدف الرعايات.</p></div>
      <div className="login-target"><span>الهدف التنفيذي</span><strong>5 ملايين ريال</strong><small>خلال 18 أسبوعًا</small></div>
    </section>
    <section className="login-panel">
      <form onSubmit={submit}>
        <div className="login-icon"><ShieldCheck /></div><h2>تسجيل دخول الفريق</h2><p>استخدم بيانات حساب لوحة حكاية هدف المصرّح به.</p>
        <label><span>البريد الإلكتروني</span><div className="input-icon"><Mail /><input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" required autoFocus /></div></label>
        <label><span>كلمة المرور</span><div className="input-icon"><LockKeyhole /><input type={show ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required /><button type="button" aria-label={show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'} onClick={() => setShow(!show)}>{show ? <EyeOff /> : <Eye />}</button></div></label>
        {error && <div className="form-error">{error}</div>}
        <button className="primary-btn login-btn" disabled={busy}>{busy ? <LoaderCircle className="spin" /> : <>دخول المنصة <ArrowLeft /></>}</button>
        <small className="security-note">الدخول محمي بصلاحيات منفصلة لكل قسم وإجراء إرسال.</small>
      </form>
    </section>
  </main>
}
